export default "__VITE_ASSET__34942133__"